// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Tab from "@insite/mobius/Tab";
import TabGroup from "@insite/mobius/TabGroup";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import closePartFinderDrawer from "@store/Framework/Store/Store/Components/PartFinder/Handlers/ClosePartFinderDrawer";
import loadReplacementsData from "@store/Framework/Store/Store/Data/PartFinder/Handlers/LoadReplacementsData";
import { PackageModel, PartModel } from "@store/Framework/Types/ApiModels";
import PartFinderListItem, {
    partFinderListStyles,
    PartFinderListStyles,
} from "@store/Library/Components/PartFinder/PartFinderListItem";
import PartFinderSchemaView from "@store/Library/Components/PartFinder/PartFinderSchemaView";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import GetCollectiveProductContext from "@toolkit/Framework/Components/ProductContext/GetCollectiveProductContext";
import React, { ChangeEvent, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    parts?: PackageModel;
}

const mapStateToProps = (state: ApplicationState) => ({
    partFinderDrawerOpen: state.store.components.partFinder.partFinderDrawerOpen,
    part: state.store.components.partFinder.part,
    tab: state.store.components.partFinder.tab,
    replacements: state.store.data.partFinder.replacements,
});

const mapDispatchToProps = {
    closePartFinderDrawer,
    loadReplacementsData,
    loadProducts,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PartFinderTableStyles {
    centeringWrapper?: InjectableCss;
    drawer?: DrawerPresentationProps;
    partImageGridItem?: PartFinderListStyles;
    partDescriptionGridItem?: PartFinderListStyles;
    partQtyPriceActionsGridItem?: PartFinderListStyles;
    qtyPriceGridItem?: PartFinderListStyles;
    actions?: PartFinderListStyles;
}

export const partFinderTableStyles: PartFinderTableStyles = {
    centeringWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            height: 135px;
            justify-content: center;
            align-items: center;
        `,
    },
    drawer: {
        position: "right",
        size: 800,
        enableClickThrough: true,
        cssOverrides: {
            scrim: css`
                overflow: visible;
                transition: none;
            `,
            drawerContainer: css``,
            drawerBody: css`
                background: white;
                padding: ${pxToRem(0, 25)};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                max-width: 100%;
                            `,
                            css`
                                max-width: 100%;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
            drawerTitle: css`
                color: ${getColor("text")};
                > span {
                    ${({ theme }) => `
                        padding:0; 
                        font-size: ${theme.design.typography.size.large}; 
                        font-weight: ${theme.design.typography.weight.light}; 
                    `}
                }
                background: ${getColor("common.background")};
                text-align: left;
                justify-content: flex-start;
            `,
            drawerContent: css`
                margin-top: ${pxToRem(-2)};
                overflow-y: auto;
                overflow-x: hidden;
            `,
            titleButton: css`
                background: ${getColor("common.background")};
                color: black;
                border: 0;
                padding: ${pxToRem(13)};
                svg {
                    color: black;
                }
            `,
        },
        closeButtonProps: {
            buttonType: "outline",
        },
    },
};

export const partFinderListStylesOverrides: PartFinderListStyles = {
    partImageGridItem: {
        width: [12, 3, 2, 2, 2],
        css: partFinderListStyles?.partImageGridItem?.css,
    },
    partDescriptionGridItem: {
        width: [12, 9, 6, 5, 6],
        css: partFinderListStyles?.partDescriptionGridItem?.css,
    },
    partQtyPriceActionsGridItem: {
        width: [12, 12, 4, 5, 4],
        css: partFinderListStyles?.partQtyPriceActionsGridItem?.css,
    },
    qtyPriceGridItem: {
        width: 12,
    },
    actions: {
        css: css`
            ${partFinderListStyles?.actions?.css}
            justify-content: flex-end;
        `,
    },
    partContainer: {
        css: css`
            margin-bottom: 1em;
            border-top: ${pxToRem(1)} solid ${getColor("common.border")};
            flex-grow: 0;
        `,
    },
};

const tabContent = css`
    border-top: ${pxToRem(3)} solid ${getColor("common.border")};
    border-bottom: none;
    padding: ${pxToRem(30, 0, 0, 0)};
    margin-top: ${pxToRem(-2)};
`;

const tabGroup = css`
    padding: 0;
    margin-top: 0;
`;

const wrapper = css`
    padding: 0;
`;

const emptyTabCss = css`
    display: none !important;
`;

const tabCss = css`
    text-transform: uppercase;
    text-align: left;
    padding: ${pxToRem(16, 0, 8, 0)};
    margin-right: ${pxToRem(40)};
    border-bottom: ${pxToRem(6)} solid transparent;
    outline: 1px dashed transparent;
    cursor: pointer;

    &:hover {
        border-bottom: ${pxToRem(6)} solid transparent;
    }

    &[aria-selected="true"] {
        border-bottom: ${pxToRem(6)} solid ${getColor("primary")};
    }

    &:focus {
        outline: 1px dashed ${getColor("common.background")};
        border-bottom: ${pxToRem(6)} solid ${getColor("primary")};
    }

    h3 {
        ${({ theme }) => `
            font-weight: ${theme.design.typography.weight.bold};
        `}
    }
`;

const styles = partFinderTableStyles;

const PartFinderDrawer = ({
    partFinderDrawerOpen,
    part,
    replacements,
    tab,
    closePartFinderDrawer,
    loadReplacementsData,
    loadProducts,
}: Props) => {
    const [isLoadingReplacements, setIsLoadingReplacements] = useState(true);
    const [isLoadingProducts, setIsLoadingProducts] = useState(true);
    const [replacementsState, setReplacementsState] = useState<PartModel[]>([]);
    const [loadedProducts, setLoadedProducts] = useState<ProductModel[]>([]);
    const [hasNoOptiProducts, setHasNoOptiProducts] = useState(false);

    const cleanup = () => {
        setHasNoOptiProducts(false);
        setIsLoadingReplacements(true);
        setIsLoadingProducts(true);
        setLoadedProducts([]);
        setReplacementsState([]);
    };

    useEffect(() => {
        if (!part || !replacements || replacements.length === 0) {
            setReplacementsState([]);
            return;
        }

        setIsLoadingProducts(true);

        const ids = replacements?.reduce((acc: string[], rep: PartModel) => {
            if (rep.id !== "00000000-0000-0000-0000-000000000000") {
                acc.push(rep.id!);
            }
            return acc;
        }, []);

        if (ids && ids.length > 0) {
            loadProducts({
                productIds: ids,
                onSuccess: (result: ProductModel[]) => {
                    setLoadedProducts(result);
                    setReplacementsState(replacements);
                    // Prevents loading both tabs at the same time blocking API
                    setTimeout(() => {
                        setIsLoadingProducts(false);
                    }, 500);
                },
            });
        } else if (replacements && replacements.length > 0) {
            setHasNoOptiProducts(true);
            setReplacementsState(replacements);
            // Prevents loading both tabs at the same time blocking API
            setTimeout(() => {
                setIsLoadingProducts(false);
            }, 500);
        }
    }, [replacements]);

    useEffect(() => {
        if (!part) {
            cleanup();
        } else if ((part?.isSuperseded || part?.hasHistory) && part?.id) {
            setIsLoadingReplacements(true);
            // Prevents loading both tabs at the same time blocking API
            setTimeout(() => {
                loadReplacementsData({
                    id: part.id,
                    partNumber: part.number,
                    onSuccess: () => {
                        setIsLoadingReplacements(false);
                    },
                });
            }, 250);
        }
    }, [part]);

    const qtyReplacementsChangeHandler = (
        event: ChangeEvent<HTMLInputElement>,
        replacements: PartModel[] | undefined,
        partId: string | undefined,
    ) => {
        const updatedQty = event.target.value;
        if (replacements) {
            const updatedParts = replacements.map(repl =>
                repl.id === partId ? { ...repl, orderQty: updatedQty } : repl,
            );
            setReplacementsState(updatedParts);
        }
    };
    return (
        <Drawer
            draggable
            position="right"
            isOpen={partFinderDrawerOpen}
            handleClose={() => closePartFinderDrawer()}
            headline={`${translate("MFR")} ${part?.number}`}
            {...styles.drawer}
        >
            {part && (
                <TabGroup current={tab} cssOverrides={{ tabContent, tabGroup, wrapper }}>
                    {part?.isSuperseded || part?.hasHistory ? (
                        <Tab headline={translate("Replacement Parts")} tabKey="replacementparts" css={tabCss}>
                            {isLoadingReplacements || isLoadingProducts ? (
                                <StyledWrapper {...styles.centeringWrapper}>
                                    <LoadingSpinner />
                                </StyledWrapper>
                            ) : (part?.isSuperseded || part?.hasHistory) && replacementsState ? (
                                replacementsState.length === 0 ? (
                                    <>{translate("Replacement products are no longer in stock.")}</>
                                ) : (
                                    <>
                                        {hasNoOptiProducts ? (
                                            <>
                                                {replacementsState.map(part => (
                                                    <PartFinderListItem
                                                        key={`${part.name}-${part.itemNumber}-${part.number}-${part.id}`}
                                                        replacements={replacementsState}
                                                        qtyReplacementsChangeHandler={qtyReplacementsChangeHandler}
                                                        part={part}
                                                        extendedStyles={partFinderListStylesOverrides}
                                                        hideDrawerActions={true}
                                                        forceLoadInventory={false}
                                                        forceLoadPricing={false}
                                                    />
                                                ))}
                                            </>
                                        ) : (
                                            <>
                                                {loadedProducts.length > 0 ? (
                                                    <GetCollectiveProductContext
                                                        products={loadedProducts}
                                                        loadInventory={true}
                                                        loadPrice={true}
                                                    >
                                                        {replacementsState.map(part => (
                                                            <PartFinderListItem
                                                                key={`${part.name}-${part.itemNumber}-${part.number}-${part.id}`}
                                                                replacements={replacementsState}
                                                                qtyReplacementsChangeHandler={
                                                                    qtyReplacementsChangeHandler
                                                                }
                                                                part={part}
                                                                extendedStyles={partFinderListStylesOverrides}
                                                                hideDrawerActions={true}
                                                                forceLoadInventory={true}
                                                                forceLoadPricing={true}
                                                            />
                                                        ))}
                                                    </GetCollectiveProductContext>
                                                ) : (
                                                    <StyledWrapper {...styles.centeringWrapper}>
                                                        <LoadingSpinner />
                                                    </StyledWrapper>
                                                )}
                                            </>
                                        )}
                                    </>
                                )
                            ) : null}
                        </Tab>
                    ) : (
                        <Tab
                            headline={translate("Replacement Parts")}
                            tabKey="replacementparts"
                            css={emptyTabCss}
                        ></Tab>
                    )}
                    {(part?.hasSvg && part?.svgLinks && part?.svgLinks.length > 0) ||
                    (part?.hasDrawing && part?.drawingLinks && part?.drawingLinks.length > 0) ? (
                        <Tab headline={translate("Schema View")} tabKey="schemaview" css={tabCss}>
                            <PartFinderSchemaView part={part} />
                        </Tab>
                    ) : (
                        <Tab headline={translate("Schema View")} tabKey="schemaview" css={emptyTabCss}></Tab>
                    )}
                </TabGroup>
            )}
        </Drawer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PartFinderDrawer);
